export const GRAPHQL_TYPE = {
  GRAPHQL: 'GRAPHQL',
  GRAPHQL_CONSOLE: 'GRAPHQL_CONSOLE',
  LINK: 'LINK',
  LOGIN: 'LOGIN',
  OPEN_PIX: 'OPEN_PIX',
  REGISTER: 'REGISTER',
  SHOPPER: 'SHOPPER',
};

export type GraphQLTypes = keyof typeof GRAPHQL_TYPE;
